import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=73ee6f68&scoped=true&"
import script from "./deal.vue?vue&type=script&lang=ts&"
export * from "./deal.vue?vue&type=script&lang=ts&"
import style0 from "./deal.vue?vue&type=style&index=0&id=73ee6f68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ee6f68",
  null
  
)

export default component.exports